import axios from 'axios';
import { attachErrorNormalizer } from './api';

const API_URL = '/api';

const authHeaders = () => {
  const t = localStorage.getItem('luxortek_admin_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

const api = axios.create({ baseURL: API_URL, timeout: 45000 });
api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() };
  return config;
});
attachErrorNormalizer(api);

// Suppliers
export const listSuppliers = (params = {}) => api.get('/admin/suppliers', { params });
export const getSupplier = (id) => api.get(`/admin/suppliers/${id}`);
export const createSupplier = (data) => api.post('/admin/suppliers', data);
export const updateSupplier = (id, data) => api.patch(`/admin/suppliers/${id}`, data);
export const deleteSupplier = (id) => api.delete(`/admin/suppliers/${id}`);

// RFQ campaigns
export const listRfqCampaigns = (params = {}) => api.get('/admin/rfq-campaigns', { params });
export const getRfqCampaign = (id) => api.get(`/admin/rfq-campaigns/${id}`);
export const getRfqTemplate = () => api.get('/admin/rfq-campaigns/template');
export const createRfqCampaign = (data) => api.post('/admin/rfq-campaigns', data);
export const updateRfqCampaign = (id, data) => api.patch(`/admin/rfq-campaigns/${id}`, data);
export const deleteRfqCampaign = (id) => api.delete(`/admin/rfq-campaigns/${id}`);
export const sendRfqCampaign = (id, data) => api.post(`/admin/rfq-campaigns/${id}/send`, data);
export const preSendCheckRfqCampaign = (id) => api.get(`/admin/rfq-campaigns/${id}/pre-send-check`);
export const listRfqEmailLogs = (params = {}) => api.get('/admin/rfq-email-logs', { params });

// Supplier quotes
export const listSupplierQuotes = (params = {}) => api.get('/admin/supplier-quotes', { params });
export const createSupplierQuote = (data) => api.post('/admin/supplier-quotes', data);
export const updateSupplierQuote = (id, data) => api.patch(`/admin/supplier-quotes/${id}`, data);
export const deleteSupplierQuote = (id) => api.delete(`/admin/supplier-quotes/${id}`);
export const exportSupplierQuotesUrl = (campaignId) =>
  `/api/admin/supplier-quotes/export${campaignId ? `?campaign_id=${campaignId}` : ''}`;

// Supplier export
export const exportSuppliersUrl = () => `/api/admin/suppliers/export`;

// TEMPORARY: one-off supplier dataset reset (removed after operator finishes).
export const dangerResetSuppliers = (confirmation_phrase, acknowledged = false) =>
  api.post('/admin/suppliers/_danger/reset', { confirmation_phrase, acknowledged });

// Supplier import
export const supplierImportPreview = (file, overwrite = false) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/admin/suppliers/import-preview?overwrite=${overwrite ? 'true' : 'false'}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const supplierImportCommit = (file, overwrite = false) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/admin/suppliers/import?overwrite=${overwrite ? 'true' : 'false'}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// RFQ Templates
export const listRfqTemplates = () => api.get('/admin/rfq-templates');
export const createRfqTemplate = (data) => api.post('/admin/rfq-templates', data);
export const deleteRfqTemplate = (id) => api.delete(`/admin/rfq-templates/${id}`);

// ─── Supplier enrichment ───────────────────────────────────────────
export const enrichSupplier = (id) => api.post(`/admin/suppliers/${id}/enrich`);
export const bulkEnrichSuppliers = () => api.post('/admin/suppliers/bulk-enrich');
export const verifySupplier = (id) => api.post(`/admin/suppliers/${id}/verify`);
export const verifySupplierEmail = (id) => api.post(`/admin/suppliers/${id}/verify-email`);
export const bulkVerifySupplierEmails = () => api.post('/admin/suppliers/bulk-verify-emails');
export const markSupplierEmailVerified = (id, notes) =>
  api.post(`/admin/suppliers/${id}/mark-email-verified`, { notes: notes || '' });

// Copy campaign
export const copyRfqCampaign = (id) => api.post(`/admin/rfq-campaigns/${id}/copy`);

// RFQ Preview (render the outgoing email body without sending)
export const previewRfq = (data) => api.post('/admin/rfq-campaigns/preview', data);

// ─── Feb-2026 — RFQ Wizard endpoints ───────────────────────────────
export const listRfqPrebuiltTemplates = () => api.get('/admin/rfq-campaigns/prebuilt-templates');
export const rfqRecipientPreview = (id, data) => api.post(`/admin/rfq-campaigns/${id}/recipient-preview`, data);
export const rfqTestSend = (id, data) => api.post(`/admin/rfq-campaigns/${id}/test-send`, data);
export const rfqSchedule = (id, data) => api.post(`/admin/rfq-campaigns/${id}/schedule`, data);
